
import { cn } from '@/lib/utils';
import { Icon } from './icon';

const TILE = {
  sm: { box: 'h-9 w-9', icon: 18 },
  md: { box: 'h-11 w-11', icon: 20 },
  lg: { box: 'h-14 w-14', icon: 24 },
} as const;

const TONE = {
  none: '',
  soft: 'bg-medlux-soft text-medlux',
  navy: 'bg-medlux text-medlux-foreground',
  highlight: 'bg-highlight-subtle text-highlight-strong',
  // Needs attention (a document still in draft): the ds mel tint.
  warning: 'bg-warning-subtle text-warning-strong',
  info: 'bg-info-subtle text-info',
  success: 'bg-success-soft text-success-soft-foreground',
  danger: 'bg-destructive-soft text-destructive-soft-foreground',
} as const;

/** Icon-badge tile: the small square (or circle) wrapping a single Icon that recurs
 *  across cards, meta rows, benefit rows and step lists. `tile` + `shape` + `tone` give
 *  the house sizes so callers stop re-typing `h-11 w-11 rounded-full bg-medlux-soft`;
 *  `size` remains the raw icon size for the legacy callers that size the box themselves. */
export function IconTile({
  name,
  size,
  tile,
  shape = 'square',
  tone = 'none',
  className,
}: {
  name: string;
  /** Icon size in px (legacy callers); defaults from `tile` when that is set. */
  size?: number;
  tile?: keyof typeof TILE;
  shape?: 'square' | 'circle';
  tone?: keyof typeof TONE;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center',
        shape === 'circle' ? 'rounded-full' : 'rounded-lg',
        tile && TILE[tile].box,
        TONE[tone],
        className,
      )}
    >
      <Icon name={name} size={size ?? (tile ? TILE[tile].icon : 18)} />
    </span>
  );
}
